import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const FamilySponsorService = () => {
    return <ServicesEditTemplate doc="family_sponsor" service="Family Sponsorship" />;
};

export default FamilySponsorService;

